import * as React from 'react';
import { Box } from '@mui/material';
import { useEasyBrowserContext } from '../../browser';

const PageBody = React.forwardRef((_props: unknown, _ref: React.ForwardedRef<any>) => {
    const { paginasRenderizadas } = useEasyBrowserContext()!;

    return (
        // position: relative é obrigatório para que as páginas com
        // position: absolute + inset: 0 se ancorem aqui e não no viewport
        <Box sx={{
            position: 'relative',
            flex: 1,           // ocupa o espaço restante abaixo da TaskBar
            overflow: 'hidden', // impede que páginas deslocadas com translateX causem scroll
        }}>
            {paginasRenderizadas}
        </Box>
    );
});

export default PageBody;